import FluigService from "../../../../services/resource/fluigComprasService"
import { useEffect, useRef, useState } from 'react';
import DistribuicaoPorFase from "./DistribuicaoPorFase";
import ResumoDepartamento from "./ResumoDepartamento";
import ResumoStatus from "./ResumoStatus";
import ResumoTempoMedio from "./resumoTempoMedio";
import { formatLocalDate, getComecoAno, getDataSeteDiasAntesFormatado, getHojeFormatado, getMesAtual, getMesPassado, returnDate, ultimoDiaMesPassado } from "../../../../utils/formatDate";
import ResumoPorFilial from "./ResumoPorFilial";
import ResumoSolicitantes from "./ResumoSolicitantes";
import TabelaSolicitacoes from "./TabelaSolicitacoes";
import { Loading } from "../../../../componentes/loading/loading";
import DropDown from "../../../../componentes/dropdown/dropdown";
import InputForm from "../../../../componentes/input/input";
import { reduzirNome } from "../../../../utils/reduzirNome";
import { intervaloDatas } from "../../../../utils/options";
import ResumoPorPrioridade from "./ResumoPorPrioridade";
import ResumoPorFilialPrioridade from "./ResumoPorPrioridadeFilial";
import { exportDashboardToPDF } from "../../../../utils/exportarDashboardEmPDF";
import { copyElementToClipboard } from "../../../../utils/copyElementToClipboard";
import { captureElementToImage } from "../../../../utils/captureElementToImage";
import SplitButton from "../../../../componentes/button-split/SplitButton";
import Button from "../../../../componentes/button/button";

const initialValues = {
    "dataInicio": "",
    "dataEncerramento": "",
    "numeroProcesso": null,
    "fase": "",
    "status": "",
    "filial": "",
    "solicitanteNome": "",
    "solicitanteEmail": "",
    "tipoProduto": "",
    "departamento": "",
    "prioridade": "",
    "motivoSolicitacao": "",
    "analistaCotacao": "",
    "valorCotacao": null,
    "gestorImediato": "",
    "gestorCorporativo": "",
    "comprador": "",
    "dataRecebimento": null,
    "valorNf": null,
    "vencimento": "",
    "diferencaValor": null
}

function RelatorioSolicitacaoCompra() {
    const service = new FluigService();
    const [loading, setLoading] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [loadingValor, setLoadingValor] = useState(false);
    const [loadingTempoMedio, setLoadingTempoMedio] = useState(false);
    const [dataInicial, setDataInicial] = useState(getMesAtual());
    const [dataFinal, setDataFinal] = useState(getHojeFormatado());
    const [filtro, setFiltro] = useState(false);
    const [filtrar, setFiltrar] = useState(false);
    const [modalSolicitacoes, setShowModalSolicitacoes] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [solicitacoes, setSolicitacoes] = useState([initialValues]);
    const [solicitacoesFiltradas, setSolicitacoesFiltradas] = useState([initialValues]);
    const [dataSelecionada, setDataSelecionada] = useState(7);
    const solicitacoesRef = useRef([]);
    const [valorGasto, setValorGasto] = useState([
        {
            "valorGasto": 0
        },
    ]);

    const [resumoStatus, setResumoStatus] = useState([
        {
            "status": "0",
            "total": 0
        },
        {
            "status": "1",
            "total": 0
        },
        {
            "status": "2",
            "total": 0
        }
    ]);

    const [resumoMediaTempo, setResumoMediaTempo] = useState([
        {
            "diasParaFinalizar": 0,
            "diasAteCotacao": 0,
            "diasAteAprovacao": 0,
            "diasAteCompra": 0
        }
    ]);

    useEffect(() => {
        setLoading(true);
        setLoadingTempoMedio(true);
        setLoadingValor(true);
        setLoadingStatus(true);

        service.resumoPorStatus(dataInicial, dataFinal).then(response => {
            setResumoStatus(response.data);
        }).catch(error => console.error("Error: ", error)).finally(() => setLoadingStatus(false));

        service.resumoMediaDias(dataInicial, dataFinal).then(response => {
            setResumoMediaTempo(response.data);
        }).catch(error => console.error("Error: ", error)).finally(() => setLoadingTempoMedio(false));

        service.buscaValorGasto(dataInicial, dataFinal).then(response => {
            setValorGasto(response.data);
        }).catch(error => console.error("Error: ", error)).finally(() => setLoadingValor(false));

        service.listaTodos(dataInicial, dataFinal).then(response => {
            setSolicitacoes(response.data);
            setSolicitacoesFiltradas(response.data);
            solicitacoesRef.current = response.data;
        }).catch(error => console.error("Error: ", error)).finally(() => setLoading(false));

    }, [filtrar]);

    useEffect(() => {
        document.title = "MyDash | Solicitação de Compras"
    }, []);

    const mudarPeriodoDeDatas = (e) => {
        const valor = e.target.value;
        setDataSelecionada(valor)
        if (valor === 14) {
            setFiltro(true);  // abre o filtro
        } else if (valor === 7) {
            setFiltro(false);
            setDataInicial(getMesAtual());
            setDataFinal(getHojeFormatado());
        } else if (valor === 30) {
            setFiltro(false);
            setDataInicial(getMesPassado());
            setDataFinal(ultimoDiaMesPassado());
        } else if (valor === 365) {
            setDataInicial(getComecoAno());
            setDataFinal(getHojeFormatado());
            setFiltro(false);
        } else {
            setFiltro(false);
            setDataInicial(getDataSeteDiasAntesFormatado(valor))
        }
    }

    const FileDownload = require('js-file-download');
    const exportarExcel = () => {
        service.exportarExcel(dataInicial, dataFinal).then(response => {
            const date = new Date();
            FileDownload(response.data, "Solicitação de Compras " + date.getTime() + ".xlsx");
        }).catch(error => {
            console.error(error)
            console.error(error.message);
        })
    }

    const retornaQuantidadePorStatus = (value) => {
        const status = resumoStatus.find(x => x.status === value);
        return status ? status.total : 0;
    }

    const openModal = (value, campo, campoExtra, valueExtra) => {
        const dataAtual = solicitacoesRef.current; // 🔹 sempre o dado mais recente
        let list = [];

        if (campo === "fase") {
            list = dataAtual.filter(data => data.fase?.substring(3) === value);
        } else {
            list = dataAtual.filter(data => data[campo]?.startsWith(value));
            if (campoExtra) {
                list = list.filter(data => data[campoExtra]?.startsWith(valueExtra));
            }
        }

        setSolicitacoesFiltradas(list);
        setShowModalSolicitacoes(true);
        setIsMounted(true);
    };


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeModal();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Limpeza do event listener ao desmontar o componente
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [setShowModalSolicitacoes]);

    function closeModal() {
        setShowModalSolicitacoes(false); // dispara fade-out
        setTimeout(() => setIsMounted(false), 300); // desmonta após a animação
    }

    return (
        <main className="px-4 py-6">
            <div className="bg-card border border-border rounded-lg shadow-card p-4 mb-3">
                <div className="flex flex-wrap justify-between items-end">
                    <div className="flex gap-3 mb-1">
                        <DropDown optional label="Período"
                            options={intervaloDatas}
                            optionLabel="label"
                            optionValue="value"
                            onChange={mudarPeriodoDeDatas}
                            value={dataSelecionada}
                            className="w-60"
                        />
                        {filtro &&
                            <>
                                <InputForm label="Data Inicial" type="date" onChange={e => setDataInicial(e.target.value)} value={dataInicial} className="h-10 px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                                <InputForm label="Data Final" type="date" onChange={e => setDataFinal(e.target.value)} value={dataFinal} className="h-10 px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                            </>
                        }
                    </div>
                    <div className="flex gap-2 items-end mb-1">
                        <SplitButton
                            label="Exportar PDF"
                            color="white"
                            textColor="black"
                            icon="fas fa-file-pdf"
                            onClick={() => {
                                const title = "Relatório de Solicitação de Compras ";
                                const subtitle = (formatLocalDate(dataInicial)) + " a " + (formatLocalDate(dataFinal));
                                exportDashboardToPDF(['solicitacoesComprasContainer'], title, subtitle)
                            }}
                            items={[
                                {
                                    label: "Baixar Imagem",
                                    icon: "fas fa-camera",
                                    onClick: () => {
                                        captureElementToImage("solicitacoesComprasContainer");
                                    },
                                },
                                {
                                    label: "Copiar Imagem",
                                    icon: "fas fa-clipboard",
                                    onClick: () => {
                                        copyElementToClipboard("solicitacoesComprasContainer");
                                    },
                                },


                            ]} />

                        <button onClick={() => setFiltrar(!filtrar)} className="bg-primary hover:brightness-95 text-primary-foreground px-4 py-2 rounded-md flex items-center transition-colors duration-150">
                            <i className="fas fa-filter mr-2"></i> Filtrar
                        </button>
                    </div>
                </div>
            </div>

            <div id="solicitacoesComprasContainer" >
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 mb-2">
                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Solicitações Finalizadas</p>
                                    {loadingStatus ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-32"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-foreground mt-1">{retornaQuantidadePorStatus("Finalizado")}</h3>
                                    }
                                </div>
                                <div className="bg-success/10 p-3 rounded-full">
                                    <i className="fas fa-file-alt text-success text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Solicitações Pendentes</p>
                                    {loadingStatus ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-32"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-foreground mt-1">{retornaQuantidadePorStatus("Aberto")}</h3>
                                    }
                                </div>
                                <div className="bg-yellow-100 p-3 rounded-full">
                                    <i className="fas fa-clock text-yellow-600 text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Tempo médio para finalizar</p>
                                    {loadingTempoMedio ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-32"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-foreground mt-1">{resumoMediaTempo[0].diasParaFinalizar || 0} dias</h3>
                                    }
                                </div>
                                <div className="bg-primary/10 p-3 rounded-full">
                                    <i className="fas fa-stopwatch text-primary text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Valor Faturado</p>
                                    {loadingValor ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-40"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-foreground mt-1">{valorGasto[0].valorGasto || 0}</h3>
                                    }
                                </div>
                                <div className="bg-purple-100 p-3 rounded-full">
                                    <i className="fas fa-money-bill-wave text-purple-600 text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2 lg:grid lg:grid-cols-12 mb-2">
                    <div className="lg:col-span-4">
                        <ResumoStatus filtrar={filtrar} data={resumoStatus} loading={loadingStatus} openModal={openModal} />
                    </div>
                    <div className="lg:col-span-4">
                        <ResumoSolicitantes dataInicial={dataInicial} dataFinal={dataFinal} filtrar={filtrar} openModal={openModal} />
                    </div>
                    <div className="lg:col-span-4">
                        <ResumoDepartamento dataInicial={dataInicial} dataFinal={dataFinal} filtrar={filtrar} openModal={openModal} />
                    </div>
                    <div className="lg:col-span-8">
                        <ResumoPorFilialPrioridade dataInicial={dataInicial} dataFinal={dataFinal} dataApi={resumoMediaTempo} filtrar={filtrar} openModal={openModal} />
                    </div>
                    <div className="lg:col-span-4">
                        <ResumoPorFilial dataInicial={dataInicial} dataFinal={dataFinal} dataApi={resumoMediaTempo} filtrar={filtrar} openModal={openModal} />
                    </div>

                    <div className="lg:col-span-8">
                        <DistribuicaoPorFase dataInicial={dataInicial} dataFinal={dataFinal} service={service} filtrar={filtrar} openModal={openModal} />
                    </div>
                    <div className="lg:col-span-4">
                        <ResumoPorPrioridade dataInicial={dataInicial} dataFinal={dataFinal} dataApi={resumoMediaTempo} filtrar={filtrar} openModal={openModal} />
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-3">
                <div className="col-span-3">
                    <ResumoTempoMedio dataApi={resumoMediaTempo} loading={loadingTempoMedio} filtrar={filtrar} openModal={openModal} />
                </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-6 mb-3">
                <div className="lg:w-full bg-card border border-border rounded-lg shadow-card p-4 h-full" >
                    <div className="flex justify-between align-items-center mb-2">
                        <h3 className="text-lg font-display font-semibold text-foreground">Lista de Solicitações</h3>
                        <Button variant="green" onClick={exportarExcel} disabled={loading} label="Exportar" iconLeft="fas fa-file-excel" />
                    </div>
                    {loading ?
                        <Loading />
                        :
                        <TabelaSolicitacoes solicitacoes={solicitacoes} service={service} dataFinal={dataFinal} dataInicial={dataInicial} />
                    }
                </div>
            </div>
            {(isMounted && !loading) &&
                <div className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100] ${modalSolicitacoes ? "fade-in" : "fade-out"}`}>
                    <div className="bg-card border border-border rounded-lg shadow-pop p-6">
                        <div className="flex justify-between">
                            <h2 className="text-xl font-display font-semibold mb-4 text-foreground">Solicitações</h2>
                            <i className="fa fa-times cursor-pointer text-muted-foreground hover:text-foreground transition-colors" onClick={closeModal} />
                        </div>
                        <div className="space-y-3">
                            <div className="overflow-y-auto max-h-[300px] border border-border rounded-lg">
                                <table className="min-w-full divide-y divide-border">
                                    <thead className="bg-table-header text-table-header-fg sticky top-0">
                                        <tr>
                                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Processo</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Início</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Status</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Fase</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Filial</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Solicitante</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-border">
                                        {solicitacoesFiltradas.map((item, index) => (
                                            <tr key={item.numeroProcesso} className="hover:bg-table-row-hover transition-colors">
                                                <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-foreground">
                                                    <a href={`http://fluig.yorkdistribuidora.com.br:35792/portal/p/1/pageworkflowview?app_ecm_workflowview_detailsProcessInstanceID=${item.numeroProcesso}`} target="_blank">
                                                        {item.numeroProcesso}
                                                    </a>
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-foreground">{returnDate(item.dataInicio?.toLocaleString())}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.status}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.fase}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{item.filial}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-muted-foreground">{reduzirNome(item.solicitanteNome)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <label className="text-sm text-muted-foreground">Registros: {solicitacoesFiltradas.length}</label>

                        </div>
                    </div>
                </div>

            }
        </main>
    );
}

export default RelatorioSolicitacaoCompra;
